@if ((availability$ | async); as availability) {
  @if (availability.branchAvailability.length > 0) {
    <h3>
      {{ availability.totals?.opacVisibleCopies }} {{ availability.totals?.opacVisibleCopies === 1 ? 'copy' : 'copies' }}
      at {{ availability.branchAvailability.length }}
      branch{{ availability.branchAvailability.length > 1 ? 'es' : '' }}
    </h3>
    <table mat-table aria-label="Item Availability" multiTemplateDataRows [dataSource]="availability.branchAvailability">
      <ng-container matColumnDef="library">
        <th mat-header-cell *matHeaderCellDef scope="col">Library</th>
        <td mat-cell *matCellDef="let b" [ngClass]="{'no-border': b.expanded}">{{ b.branchName }}</td>
      </ng-container>
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef scope="col">Location</th>
        <td mat-cell *matCellDef="let b">
          <mat-chip-set>
            @if (b.patronHomeBranch) {
              <mat-chip class="blue-pill">
                Home Branch
              </mat-chip>
            }
            @if (!b.patronHomeBranch) {
              <mat-chip class="white-pill">
                In Network
              </mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>
      <ng-container matColumnDef="availability">
        <th mat-header-cell *matHeaderCellDef scope="col">Item Availability</th>
        <td mat-cell *matCellDef="let b">
          <rn-availability-count-pill [available]="b.availableCount" [copies]="b.opacVisibleCopies"/>
        </td>
      </ng-container>
      <ng-container matColumnDef="expand-trigger">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let b">
          @if (!b.expanded) {
            <a class="expand-trigger" (click)="expansionClick(b)">+</a>
          }
          @if (b.expanded) {
            <a class="expand-trigger" (click)="expansionClick(b)">-</a>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="expanded">
        <td [attr.colspan]="displayColumns.length" class="teal-background" mat-cell *matCellDef="let b">
          <rn-catalog-details-branch-availability [branchAvailability]="b" style="width: 100%"/>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns" class="mx-bold-underline" [ngClass]="{'no-padding': mobile}"></tr>
      <tr mat-row *matRowDef="let b; columns: displayColumns"
          [ngClass]="{'teal-background': false && b.expanded && !mobile, 'no-border': b.expanded, 'mx-taller-row': !mobile, 'no-padding': mobile}"></tr>
      <tr mat-row *matRowDef="let b; columns: ['expanded']; when: expanded"></tr>
    </table>
  } @else {
    <div class="empty-list center-center">
      This catalog entry does not have any items associated with it.
    </div>
  }
} @else {
  <div class="spinner-container center-center">
    <mat-spinner/>
  </div>
}
